var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2499 19.1888L19.1894 17.2493L13.8231 11.883L17.7576 9.2595L5.61887 5.61825L9.26012 17.757L11.8836 13.8225L17.2499 19.1888ZM17.2499 20.9993C17.0579 20.9993 16.8659 20.9258 16.7196 20.7795L12.1161 16.176L9.62387 19.9155C9.46337 20.1563 9.18062 20.283 8.88887 20.241C8.60162 20.1983 8.36462 19.9928 8.28137 19.7145L3.78137 4.7145C3.70262 4.4505 3.77462 4.164 3.96962 3.969C4.16462 3.77325 4.45187 3.702 4.71512 3.78075L19.7151 8.28075C19.9934 8.364 20.1989 8.601 20.2416 8.88825C20.2844 9.1755 20.1576 9.462 19.9161 9.62325L16.1766 12.1155L20.7801 16.719C21.0734 17.0123 21.0734 17.4863 20.7801 17.7795L17.7801 20.7795C17.6339 20.9258 17.4419 20.9993 17.2499 20.9993Z",
    fill: "#F67E7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningLink);
export default __webpack_public_path__ + "static/media/warning-link.53deefd7640324aca4cad1415830728e.svg";
export { ForwardRef as ReactComponent };